import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { logoutUser } from '@leanpay/services'

import MainAppSLO from './main-app-slo'
import { useAppStore } from 'app/app-context'
import { LayoutHeader } from 'components/layout-header/layout-header'
import { handleProgress } from 'library/utils/utils'

const MainLayout = () => {
    const location = useLocation()
    const { isAuthenticated, progress, setProgress, setIsAuthenticated } = useAppStore()

    useEffect(() => {
        handleProgress(location.pathname, setProgress)
    }, [location.pathname, setProgress])

    const handleLogout = () => {
        logoutUser()
        setIsAuthenticated(false)
    }
    return (
        <div className="main-layout flex flex-col self-center items-center max-w-[840px] w-full bg-lp-grey2 min-h-screen rounded-md shadow-xs lg:max-h-[95vh] lg:min-h-[95vh] lg:overflow-y-scroll lg:[&::-webkit-scrollbar]:hidden lg:[-ms-overflow-style:none] lg:[scrollbar-width:none]">
            <LayoutHeader
                isAuthenticated={isAuthenticated}
                onLogout={handleLogout}
                progress={progress}
            >
                <MainAppSLO />
            </LayoutHeader>
        </div>
    )
}

export default MainLayout
